// src/components/cursos/ItemEstadoCurso.jsx
import PropTypes from 'prop-types';
import { Box, ButtonBase, Tooltip, Typography } from '@mui/material';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckIcon from '@mui/icons-material/Check';

const iconos = {
    sin_comenzar: ChangeHistoryIcon,
    en_proceso: RadioButtonUncheckedIcon,
    completado: CheckIcon
};

const ItemEstadoCurso = ({ color, num, msj, selected, onClick, tipoIcono }) => {
    const Icono = iconos[tipoIcono] || ChangeHistoryIcon;
    const isDisabled = num === 0;

    const mensajesVacios = {
        sin_comenzar: 'No hay cursos sin comenzar por mostrar',
        en_proceso: 'No hay cursos en proceso por mostrar',
        completado: 'No hay cursos completados por mostrar'
    };

    const mensajeTooltip = isDisabled ? mensajesVacios[tipoIcono] : msj;

    const buttonContent = (
        <ButtonBase
            onClick={isDisabled ? undefined : onClick}
            disabled={isDisabled}
            sx={{
                borderRadius: '14px',
                overflow: 'hidden',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                pointerEvents: isDisabled ? 'none' : 'auto'
            }}
        >
            <Box
                sx={{
                    minWidth: '1rem',
                    minHeight: '1rem',
                    px: 1.5,
                    py: 1.2,
                    borderRadius: '14px',
                    backgroundColor: isDisabled ? '#E0E0E0' : color,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    border: selected ? '2px solid rgba(0,0,0,0.35)' : '2px solid transparent',
                    boxShadow: selected ? '0 0 0 2px rgba(0,0,0,0.08)' : 'none',
                    transition: 'all 0.2s ease',
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    '&:hover': {
                        transform: isDisabled ? 'none' : 'scale(1.03)',
                        boxShadow: isDisabled ? 'none' : '0 4px 10px rgba(0,0,0,0.12)'
                    }
                }}
            >
                <Icono
                    sx={{
                        fontSize: 18,
                        mb: 0.5,
                        color: isDisabled ? 'rgba(0,0,0,0.38)' : 'rgba(0,0,0,0.65)',
                        backgroundColor: isDisabled ? '#E0E0E0' : color
                    }}
                />

                <Typography
                    sx={{
                        fontSize: '16px',
                        fontWeight: 700,
                        lineHeight: 1.1,
                        color: isDisabled ? 'rgba(0,0,0,0.38)' : 'rgba(0,0,0,0.75)'
                    }}
                >
                    {num}
                </Typography>
            </Box>
        </ButtonBase>
    );
    if (isDisabled) {
        return (
            <Tooltip title={mensajeTooltip} placement="top" arrow>
                <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>{buttonContent}</span>
            </Tooltip>
        );
    }
    return (
        <Tooltip title={mensajeTooltip} placement="top" arrow>
            {buttonContent}
        </Tooltip>
    );
};

ItemEstadoCurso.propTypes = {
    color: PropTypes.string,
    num: PropTypes.number,
    msj: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    tipoIcono: PropTypes.oneOf(['sin_comenzar', 'en_proceso', 'completado'])
};

ItemEstadoCurso.defaultProps = {
    color: '#EEEEEE',
    num: 0,
    msj: '',
    selected: false,
    onClick: () => {},
    tipoIcono: 'sin_comenzar'
};

export default ItemEstadoCurso;
